import { createEnum } from "../../../utils/utils";

export interface CreateMerchantUser {
  emailAddress: string;
  password: string;
  confirmPassword: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  dateOfBirth: string;
  nationality: string;
}

export interface UserCreated {
  id: string;
}

export const StatusEnum = createEnum({
  PENDING: "Pending",
  VERIFIED: "Verified",
  FAILED: "Failed",
  DECLINED: "Declined",
  DELETED: "Deleted",
  NA: "Not Available",
  NOT_VERIFIED: "Not Verified",
  NOT_FOUND: "Not Found",
  FOUND: "Found",
  IN_REVIEW: "In Review",
});

export type StatusEnum = typeof StatusEnum.T;

export const TwoFAProviders = createEnum({
  NONE: "NONE",
  TOTP: "TOTP",
});
